import { Box, Button, styled } from "@mui/material";

export const CantAccessBox = styled(Box)`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
